import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/providersServicesTable';
import filters from '@/components/builders/configs/filters/providersServicesFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import editorDialog from './submodules/EditorDialog';

const providersServicesRepository = RepositoryFactory.get('providers');
const externalPanelsRepository = RepositoryFactory.get('externalPanels');
const state = {
  repository: providersServicesRepository,
  externalPanelsRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: providersServicesRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
    editorDialog,
  },
  getters,
  mutations,
  actions,
});
